import { ApolloClient, gql, NormalizedCacheObject } from '@apollo/client';

export const addAudienceQuestion = async(question: string, client:ApolloClient<NormalizedCacheObject>|undefined) => {
  const AUDIENCE_QUESTION = gql `mutation CreateQuestion($question:String!){
      AudienceQuestionAdd(question: $question) {
        Metadata {
          requestId
        }
      }
    }`
  const variables = {
    question: question
  }
try{
  const res = await client?.mutate({
    mutation: AUDIENCE_QUESTION,
    variables: variables,
  })
  return res?.data;
}catch(error){
   console.error('Mutation error:', error);
   throw error;
 }; 
}